import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { useLang } from '../context/LanguageContext';
import useReveal from '../hooks/useReveal';
import ServiceIcon from '../components/ServiceIcon';
import CTABand from '../components/CTABand';
import { SERVICES, IMAGES } from '../data/content';

export default function Services() {
  const { t, lang } = useLang();
  const cn = lang === 'zh' ? 'font-cn' : '';
  useReveal([lang]);

  return (
    <div>
      <section className="relative pt-40 pb-24 overflow-hidden">
        <div className="absolute inset-0">
          <img src={IMAGES.officeWide} alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 hero-overlay" />
          <div className="absolute inset-0 grain" />
        </div>
        <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
          <p className={`text-[#C6A15B] tracking-[0.3em] uppercase text-xs mb-4 animate-fadeUp ${cn}`}>{t('services.eyebrow')}</p>
          <h1 className={`font-serif-display text-4xl md:text-5xl font-semibold text-white max-w-3xl animate-fadeUp text-balance ${cn}`} style={{ animationDelay: '0.15s' }}>{t('services.title')}</h1>
          <div className="gold-rule mt-6 animate-fadeUp" style={{ animationDelay: '0.3s' }} />
        </div>
      </section>

      <section className="py-24 bg-[#FAF8F3]">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="space-y-6">
            {SERVICES.map((s, i) => (
              <Link
                key={s.slug}
                to={`/servicios/${s.slug}`}
                className="svc-card lift reveal group grid md:grid-cols-12 bg-white rounded-sm border border-[#eadfca] overflow-hidden hover:shadow-2xl"
              >
                <div className="md:col-span-4 relative h-56 md:h-auto overflow-hidden">
                  <img src={s.image} alt="" className="svc-img w-full h-full object-cover" />
                  <div className="absolute inset-0 bg-gradient-to-t md:bg-gradient-to-r from-[#0B1F3A]/60 to-transparent" />
                </div>
                <div className="md:col-span-8 p-8 flex items-center">
                  <div className="w-full">
                    <div className="flex items-center gap-4 mb-3">
                      <span className="flex items-center justify-center w-12 h-12 rounded-sm bg-[#0B1F3A] text-[#C6A15B] shrink-0">
                        <ServiceIcon name={s.icon} className="w-6 h-6" />
                      </span>
                      <h3 className={`font-serif-display text-2xl font-semibold text-[#0B1F3A] group-hover:text-[#A9853E] transition-colors ${cn}`}>{s[lang].title}</h3>
                    </div>
                    <p className={`text-[#5c6470] leading-relaxed mb-4 ${cn}`}>{s[lang].short}</p>
                    <span className={`inline-flex items-center gap-1.5 text-[#A9853E] font-medium ${cn}`}>
                      {t('services.detail')} <ArrowUpRight className="w-4 h-4 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <CTABand />
    </div>
  );
}
